import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=847979a2"
import script from "./ProfileData.vue?vue&type=script&lang=ts"
export * from "./ProfileData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports